import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import CUSTOM_PARAMETERS from "./CUSTOM_PARAMETERS";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import MDIGITAL_LOCALIZATION from "./MDIGITAL_LOCALIZATION";

function getLangCodeFromCP(formNode) {
		var formId = KAMPYLE_UTILS.getNestedPropertyValue(formNode, 'formId');
		var customParamId = KAMPYLE_UTILS.getNestedPropertyValue(formNode, 'formLocalizationSettings.customParam');
		var formData = KAMPYLE_DATA.getFormData(formId) || {};
		var customParam = CUSTOM_PARAMETERS.getCustomParamById(customParamId, formData) || {};
		return CUSTOM_PARAMETERS.fetchCPValue(customParam) || 	KAMPYLE_UTILS.getNestedPropertyValue(formNode, 'formLocalizationSettings.defaultLanguage');
	}

	function getLangCode(formNode) {
		var shouldUseCustomParam = KAMPYLE_UTILS.isTruthy(
			KAMPYLE_UTILS.getNestedPropertyValue(formNode, 'formLocalizationSettings.useCustomParam')
		);
		return shouldUseCustomParam
			? MDIGITAL_LOCALIZATION.getLangCodeFromCP(formNode)
			: KAMPYLE_UTILS.getLangCodeFromNavAPI();
	}

	function getLangaugeFallback(formNode, languageCode) {
		var availableLanguages = KAMPYLE_UTILS.getNestedPropertyValue(formNode, 'availableLanguages');
		var defaultLanguage = formNode.formLocalizationSettings.defaultLanguage;
		var mainLanguage = languageCode.split('-')[0].toLowerCase();
		var foundFallback =
			availableLanguages.find(function(lang) {
				// example: if language is en-us and not found on availableLanguages this function is called, first it will search for the mainLanguage: en, if not found -> other dialects en-uk, en-au and will return the first one, if not found other dialect -> return default
				return lang.toLowerCase() === mainLanguage;
			}) ||
			availableLanguages.find(function(lang) {
				return lang.indexOf(mainLanguage) === 0; // starts with the main language - the find it finds
			});
		return foundFallback || defaultLanguage;
	}

	function detectUsableLanguageCode(formNode) {
		if (!formNode.availableLanguages) {
			return null;
		}
		var langCodeCandidate = getLangCode(formNode) || '';
		if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.UNDERSCORE_LOCALIZATION)) {
			//support underscore for langs are like 'en_bz' and replace it to 'en-bz'
			langCodeCandidate = langCodeCandidate.replace('_', '-');
		}
		return (
			formNode.availableLanguages.find(function(lang) {
				return lang.toLowerCase() === langCodeCandidate.toLowerCase();
			}) || getLangaugeFallback(formNode, langCodeCandidate)
		);
	}

	// Public API
	function getLanguageCodeByForm(formNode){
		return MDIGITAL_LOCALIZATION.detectUsableLanguageCode({
			availableLanguages: formNode.availableLanguages,
			formLocalizationSettings: formNode.formLocalizationSettings,
			formId: formNode.formId
		});
	}
	
	function getLocalizedButtonText(formNode) {
		var langCodeMemKey = KAMPYLE_CONSTANT.LANG_MEMORY_DATA_KEY_PREFIX + formNode.formId;
		var languageCode = KAMPYLE_DATA.getMemoryData(langCodeMemKey);
		if (!languageCode) {
			// if no language was set on memoryData
			languageCode = getLanguageCodeByForm(formNode);
			KAMPYLE_DATA.setMemoryData(langCodeMemKey, languageCode);
		}
		var textLocalization = KAMPYLE_UTILS.getNestedPropertyValue(formNode, 'buttonData.textLocalization') || {};
		var buttonData = textLocalization[languageCode] || formNode.buttonData.text;
		if(buttonData && typeof buttonData === 'object'){
			buttonData = buttonData.buttonText;
		}
		return buttonData;
	}

	function detectAndSetFormLanguage(formNode) {
		if (!formNode) {
			return null;
		}
		var langCodeMemKey = KAMPYLE_CONSTANT.LANG_MEMORY_DATA_KEY_PREFIX + formNode.formId;
		var detectedLanguage = getLanguageCodeByForm(formNode);
		KAMPYLE_DATA.setMemoryData(langCodeMemKey, detectedLanguage);
		return detectedLanguage;
	}

	function isFormLanguageRtl(formNode){
		var languageCode = getLanguageCodeByForm(formNode);
		var buttonData = KAMPYLE_UTILS.getNestedPropertyValue(formNode, 'buttonData.textLocalization') || {};
		return buttonData[languageCode] && buttonData[languageCode].isRtl === 'true';
	}

	function getFormLanguage(formId) {
		var formData = KAMPYLE_DATA.getFormData(formId) || {};
		if (!formData) {
			return null;
		}
		return (
			KAMPYLE_DATA.getMemoryData(KAMPYLE_CONSTANT.LANG_MEMORY_DATA_KEY_PREFIX + formId) ||
			detectAndSetFormLanguage(formData)
		);
	}

	export default {
		// for testing
		getLangCodeFromCP: getLangCodeFromCP,
		getLangCode: getLangCode,
		getLangaugeFallback: getLangaugeFallback,
		detectUsableLanguageCode: detectUsableLanguageCode,
		detectAndSetFormLanguage: detectAndSetFormLanguage,
		
		// public api
		getLocalizedButtonText: getLocalizedButtonText,
		getFormLanguage: getFormLanguage,
		isFormLanguageRtl: isFormLanguageRtl
	};
